import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import { ModalLoad } from "../../components/Modals/Modals";
import { LanguageProvider } from "../../components/Layout/LanguageContext";
import { useCheckSession, useUserData } from "../../features/auth";
import mySessionStorage from "../../controllers/sessionStorage.controllers";
import { validationValue } from "../../utils/validations";

const Login = lazy(() => import("../../pages/Login/Login"));
const Code = lazy(() => import("../../pages/Code/Code"));
const Layout = lazy(() => import("../../components/Layout/Layout"));

export const Route = createFileRoute("/$lang/_authenticated")({
  component: AuthenticatedLayout,
  pendingComponent: () => <ModalLoad />
});

function AuthenticatedLayout() {
  const { data: isAuth, isLoading: isLoadingSession } = useCheckSession();
  const { data: userData, isLoading: isLoadingUser } = useUserData(
    isAuth === true
  );

  const sessionWithCode = validationValue(
    mySessionStorage.get("sessionWithCode"),
    null
  );

  const isLoading = isLoadingSession || (isAuth && isLoadingUser);
  const sessionADAC =
    userData?.user?.type === "ADAC" || mySessionStorage.get("sessionADAC");


  if (isLoading) {
    return <ModalLoad />;
  }

  if (!isAuth && (sessionADAC == null || sessionADAC == false)) {
    return (
      <Suspense fallback={<ModalLoad />}>
        <Login />
      </Suspense>
    );
  }

  if (sessionADAC && !sessionWithCode) {
    return (
      <LanguageProvider>
        <Suspense fallback={<ModalLoad />}>
          <Code />
        </Suspense>
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <Layout>
        <Outlet />
      </Layout>
    </LanguageProvider>
  );
}
